import { Attributes, Misc, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class DividendLetterCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    public entityId: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public dividendDate: Date | null = null;

    @Attributes.Nullable()
    public investmentId: number | null = null;

    @Attributes.Nullable()
    public dividendAccrualId: number | null = null;

    @Attributes.Nullable()
    public dividendId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Dividend Letter Criteria";
    }
}